import { Component, Input, OnInit } from '@angular/core';
import { ResponsiveService } from '@frk/eds-components';
import { UsTaxDistribution } from '@products/models/us-tax';
import { BaseTableResponsiveComponent } from '@shared/table/base-table-responsive.component';
import { TranslateService } from '@shared/translate/translate.service';

@Component({
  selector: 'ft-us-tax-distributions',
  templateUrl: './us-tax-distributions.component.html',
  styleUrls: ['./us-tax-distributions.component.scss'],
})
export class UsTaxDistributionsComponent
  extends BaseTableResponsiveComponent
  implements OnInit {
  @Input() distributions: UsTaxDistribution[];
  tooltips: { [name: string]: string } = {};

  constructor(
    responsiveService: ResponsiveService,
    private translateService: TranslateService
  ) {
    super(responsiveService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.tooltips[
      'products.us-tax-record-date'
    ] = this.translateService.tooltip('products.us-tax-record-date');
    this.tooltips[
      'products.us-tax-ordinary-dividends'
    ] = this.translateService.tooltip('products.us-tax-ordinary-dividends');
    this.tooltips[
      'products.us-tax-qualified-dividends'
    ] = this.translateService.tooltip('products.us-tax-qualified-dividends');
    this.tooltips[
      'products.us-tax-cap-gain-distributions'
    ] = this.translateService.tooltip('products.us-tax-cap-gain-distributions');
    this.tooltips[
      'products.us-tax-unrecaptured-section-1250-gain'
    ] = this.translateService.tooltip(
      'products.us-tax-unrecaptured-section-1250-gain'
    );
    this.tooltips[
      'products.us-tax-nontaxable-return-of-capital'
    ] = this.translateService.tooltip(
      'products.us-tax-nontaxable-return-of-capital'
    );
    this.tooltips[
      'products.us-tax-section-199a-dividends'
    ] = this.translateService.tooltip('products.us-tax-section-199a-dividends');
    this.tooltips[
      'products.us-tax-foreign-tax-paid'
    ] = this.translateService.tooltip('products.us-tax-foreign-tax-paid');
    this.tooltips[
      'products.us-tax-exempt-interest-dividends'
    ] = this.translateService.tooltip(
      'products.us-tax-exempt-interest-dividends'
    );
    this.tooltips[
      'products.interest-on-tax-reclaim-refunds'
    ] = this.translateService.tooltip(
      'products.interest-on-tax-reclaim-refunds'
    );
  }
}
